// @ts-strict-ignore
/**
 * @owner @Appboy/reporting
 * @fileoverview GET handler for the "/subscription_group_analytics/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { subscriptionGroupAnalyticsCacheKeys } from "./constants";
import type { SubscriptionGroupAnalyticsResult } from "./types";

export const getSubscriptionGroupAnalytics = reactQueryFetcherAdapter(
  subscriptionGroupAnalyticsCacheKeys,
  (
    signal: AbortSignal,
    appGroupId: string,
    startDate: number,
    endDate: number,
    channels: string[] | undefined,
    subscriptionGroupId: string | undefined
  ): Promise<SubscriptionGroupAnalyticsResult> => {
    return fetch(
      `/subscription_group_analytics/${appGroupId}`,
      "GET",
      {
        start_date: startDate,
        end_date: endDate,
        channels,
        subscription_group_id: subscriptionGroupId,
      },
      { signal }
    );
  }
);
